import { render, staticRenderFns } from "./SignUpDashboard.vue?vue&type=template&id=41b53553&scoped=true&"
import script from "./SignUpDashboard.vue?vue&type=script&lang=js&"
export * from "./SignUpDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b53553",
  null
  
)

export default component.exports